var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:_vm.classObject,on:{"mouseenter":this.$root.toogleAsideHover,"mouseleave":this.$root.toogleAsideHover}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }